// Lucide icon: plane (https://lucide.dev/icons/plane)
import { Plane } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconAirfare = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Plane />
    </IconComponentStyled>
  )
}
